import DataVScrollTable2 from './scroll-table';
export default DataVScrollTable2;
